import { render, staticRenderFns } from "./ItsOrderCustomsApplyDetail.vue?vue&type=template&id=7e0fa3f7&scoped=true&"
import script from "./ItsOrderCustomsApplyDetail.vue?vue&type=script&lang=js&"
export * from "./ItsOrderCustomsApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsOrderCustomsApplyDetail.vue?vue&type=style&index=0&id=7e0fa3f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0fa3f7",
  null
  
)

export default component.exports